import { WalletSmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";
import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { DateRangePickerProps } from "src/components/DatePicker";

export type BatchContractSweepFilterFields = {
  chainName: string;
  currency: string;
  spenderAddress: string;
  threshold: string;
  maxNumberOfAddresses: string;
  isSmartAccount: boolean;
  isFreeBandwidthOnly: boolean;
  riskType: string;
  walletVersion: string;
};

export type BatchContractSweepPreviewParams = {
  chainId: string;
  chainType: string | number;
  assetName: string;
  spenderAddress: string;
  threshold?: string;
  limit: string;
  decimals?: number;
  riskType: string;
  smartAccountType?: WalletSmartAccountType; //expired
  tronFreeBandwidthOnly?: boolean;
  walletVersion: string;
};

export const initBatchContractSweepFilterFields: BatchContractSweepFilterFields =
  {
    chainName: "",
    currency: "",
    spenderAddress: "",
    threshold: "",
    riskType: "",
    maxNumberOfAddresses: "1000",
    isSmartAccount: false,
    isFreeBandwidthOnly: false,
    walletVersion: "",
  };

export type BatchContractSweepFormContextType = {
  fields: BatchContractSweepFilterFields;
  setFields: Dispatch<SetStateAction<BatchContractSweepFilterFields>>;
  onPreview: () => Promise<void>;
  previewParams: BatchContractSweepPreviewParams;
  isLoading: boolean;
  WalletSettlementTimePicker: (p: DateRangePickerProps) => JSX.Element;
  translate: (key: string, params?: Record<string, any>) => string;
};

export const BatchContractSweepFormContext =
  createContext<BatchContractSweepFormContextType | null>(null);

export const useBatchContractSweepFormContext = () => {
  const context = useContext(BatchContractSweepFormContext);

  if (!context) {
    throw new Error(
      "useBatchContractSweepFormContext must be used within a BatchContractSweepContextProvider",
    );
  }

  return context;
};
